import Employee from './Employee'
export class ChangePhoneNumberRequest {
    EmployeeID: number;
    NewPhoneNumber?: string;
    SavedByEmployee: Employee;
}

export default ChangePhoneNumberRequest;